import React from 'react';
import styles from './LogoEditorCard.module.scss';
import cx from 'classnames';
import noLogo from '../../assets/icons/noLogo.svg';
import { useTranslation } from 'react-i18next';

const LogoEditorCard = ({ logo = null, active, onChoose }) => {
  const { t } = useTranslation();

  const handleLogoChosen = () => {
    onChoose(logo);
  };
  return (
    <li onClick={handleLogoChosen} className={cx(styles.logoContainer, { [styles.active]: active })}>
      {!logo ? <img src={noLogo} style={{ width: '80px' }} alt='NoLogo' /> : <img src={logo.path} className={styles.logoImage} alt={t('logo_chooser.header')} />}
    </li>
  );
};

export default LogoEditorCard;
